import axios from 'axios';
import { TMM_URL, BACKOFFICE_URL } from 'toolkit/constants';
import { getDeviceId, peekFingerprint } from 'libraries/device';

export const tmmInstance = axios.create({
  baseURL: TMM_URL,
  headers: { 'app-key': 'forza-stack' }
});

export const backOfficeInstance = axios.create({
  baseURL: BACKOFFICE_URL,
  headers: { 'app-key': 'forza-stack' }
});

// Lets the server recognise the browser behind a player login
backOfficeInstance.interceptors.request.use((config) => {
  config.headers['X-Device-Id'] = getDeviceId();
  const fingerprint = peekFingerprint();
  if (fingerprint) {
    config.headers['X-Device-Fingerprint'] = fingerprint;
  }
  return config;
});

export const setToken = (token) => {
  if (token) {
    localStorage.setItem('token', token);
    backOfficeInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
    tmmInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem('token');
    delete backOfficeInstance.defaults.headers.common.Authorization;
    delete tmmInstance.defaults.headers.common.Authorization;
  }
};

let isRedirectingToLogin = false;

// A 401 means "session expired" only when a token was actually sent. Requests
// sent without a token (sign-in) or that opt out with `skipAuthRedirect` get
// their 401 back as a normal error so the caller can show it to the user.
const handleResponseError = (error) => {
  const sentToken = Boolean(error.config?.headers?.Authorization);
  const skipRedirect = error.config?.skipAuthRedirect;

  if (error.response?.status === 401 && sentToken && !skipRedirect) {
    setToken(null);
    // Parallel requests can all fail with 401; redirect only once
    if (!isRedirectingToLogin) {
      isRedirectingToLogin = true;
      window.location.href = '/login';
    }
  }
  return Promise.reject(error);
};

tmmInstance.interceptors.response.use((response) => response, handleResponseError);
backOfficeInstance.interceptors.response.use((response) => response, handleResponseError);
